// generated from 8 samples

import { z } from "zod";

export const checkoutStartedEventTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::CheckoutStartedEvent"),
  // null: 6 (75.00%)
  storefront: z.string().nullable(),
});
